<div class="sidebar">
  <ul>
    <li>
      <a [ngClass]="{ active: isHomeActive() }" routerLink="/">
        <img
          src="../../assets/img/icons/icon-1.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-1-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Início</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission(
          'PAINEL_EVENTOS_MENU',
          this.permissions
        )
      "
    >
      <a
        [ngClass]="{ active: isPainelEventosActive() }"
        routerLink="/painel-evento"
      >
        <img
          src="../../assets/img/icons/icon-2.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-2-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Painel de Eventos</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission('GRID_MENU', this.permissions)
      "
    >
      <a [ngClass]="{ active: isGridActive() }" routerLink="/grid">
        <img
          src="../../assets/img/icons/icon-grid.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-grid-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Grid</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission(
          'GRAFICO_EVENTOS_MENU',
          this.permissions
        )
      "
    >
      <a
        [ngClass]="{ active: isGraficoEventosActive() }"
        routerLink="/painel-evento-grafico"
      >
        <img
          src="../../assets/img/icons/icon-7.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-7-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Gráfico de Eventos</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission(
          'REGISTRATIONS_MENU',
          this.permissions
        )
      "
    >
      <a
        [ngClass]="{ active: isRegistrationsActive() }"
        routerLink="/registrations"
      >
        <img
          src="../../assets/img/icons/icon-3.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-3-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Cadastros</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission('CONSULTA_MENU', this.permissions)
      "
    >
      <a
        [ngClass]="{ active: isConsultationsActive() }"
        routerLink="/consultations"
      >
        <img
          src="../../assets/img/icons/icon-4.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-4-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Consultas</span>
      </a>
    </li>
    <li
      *ngIf="
        this.permissionService.hasPermission('RELATORIO_MENU', this.permissions)
      "
    >
      <a [ngClass]="{ active: isReportsActive() }" routerLink="/reports">
        <img
          src="../../assets/img/icons/icon-5.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-5-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Relatórios</span>
      </a>
    </li>
    <li
      *ngIf="this.permissionService.hasPermission('BI_MENU', this.permissions)"
    >
      <a [ngClass]="{ active: isBiActive() }" routerLink="/bi">
        <img
          src="../../assets/img/icons/icon-8.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-8-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Business Intelligence</span>
      </a>
    </li>
    <li>
      <a [ngClass]="{ active: isSettingsActive() }" routerLink="/settings">
        <img
          src="../../assets/img/icons/icon-6.svg"
          width="40"
          class="img-icon"
          alt=""
        />
        <img
          src="../../assets/img/icons/icon-6-hover.svg"
          width="40"
          class="img-icon-hover"
          alt=""
        />
        <span>Configurações</span>
      </a>
    </li>
  </ul>
</div>
